import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ModalDelete, Table } from '..';
import { REASON_REFUSAL_HEADERS } from '../../constants/table-headers';
import useDeleteReasonRefusal from '../../hooks/reasonRefusal/useDeleteReasonRefusal';
import useGetReasonRefusal from '../../hooks/reasonRefusal/useGetReasonRefusal';
import useGetReasonsRefusal from '../../hooks/reasonRefusal/useGetReasonsRefusal';
import { ApplicationState } from '../../store';
import ActivityIndicator from '../ActivityIndicator';
import Pagination from '../atoms/pagination';
import ModalReasonRefusal from './ModalReasonRefusal';
import BoxWrapper from '../atoms/boxWrapper';

const TableReasonRefusal: React.FC = () => {
  const [loadingGetReasons, setLoadingGetReasons] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [open, setOpen] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [id, setId] = useState('');
  const [idToDelete, setIdToDelete] = useState('');

  const { rows, totalRecords } = useSelector(
    (state: ApplicationState) => state.reasonRefusal,
  );
  const { execute, loading } = useGetReasonsRefusal();
  const { execute: executeGetReasonRefusal } = useGetReasonRefusal();
  const { execute: executeDeleteReasonRefusal, loading: loadingDelete } =
    useDeleteReasonRefusal();

  const handleUpdateReasonRefusal = async (id: string) => {
    await executeGetReasonRefusal(id);
    setOpen(true);
    setId(id);
  };

  const handleDeleteReasonRefusal = async () => {
    setLoadingGetReasons(true);
    await executeDeleteReasonRefusal(idToDelete, () => {
      setIdToDelete('');
      setOpenDeleteModal(!openDeleteModal);
    });
    setLoadingGetReasons(true);
    await execute({ page: currentPage, rowsPerPage: 20 });
    setLoadingGetReasons(false);
  };

  const loadReasonRefusal = useCallback(async () => {
    await execute({ page: currentPage });
    //eslint-disable-next-line
  }, [currentPage]);

  useEffect(() => {
    loadReasonRefusal();
  }, [loadReasonRefusal]);

  if (loading || loadingDelete) {
    return <ActivityIndicator />;
  }

  return (
    <BoxWrapper>
      <ModalReasonRefusal open={open} setOpen={setOpen} reasonRefusalId={id} />
      <ModalDelete
        show={openDeleteModal}
        onConfirmClick={handleDeleteReasonRefusal}
        onHide={() => setOpenDeleteModal(!openDeleteModal)}
        message="Deseja realmente excluir o motivo de recusa?"
      />
      <Table
        columns={REASON_REFUSAL_HEADERS}
        data={rows}
        onEditClick={(id: string) => handleUpdateReasonRefusal(id)}
        onDeleteClick={(id: string) => {
          setIdToDelete(id);
          setOpenDeleteModal(true);
        }}
      />
      <Pagination
        totalRecords={totalRecords}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rowsPerPage={20}
      />
    </BoxWrapper>
  );
};

export default TableReasonRefusal;
